'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function ProgressIconPersister() {
	const self = observable(this);
	let currentResolve,
		currentIcon;
	self.editProgressIcon = function (icon) {
		currentIcon = icon;
		return new Promise(function (resolve) {
			currentResolve = resolve;
			self.dispatchEvent('progressIconEditRequested');
		});
	};
	self.cancelEditProgressIcon = function () {
		if (currentResolve) {
			currentResolve(currentIcon);
		}
	};
	self.setIcon = function (source, url, imgWidth, imgHeight, position, nodeId, metaData) {
		if (url) {
			currentIcon = {
				url: url,
				width: imgWidth,
				height: imgHeight,
				position: position
			};
			if (metaData) {
				currentIcon.metaData = metaData;
			}
		} else {
			currentIcon = false;
		}
		if (currentResolve) {
			currentResolve(currentIcon);
		}
	};
	self.dropImage = function () {

	};
	self.getIcon = function () {
		return currentIcon;
	};
};
